export default "__VITE_ASSET__DCP_aRXY__"